import {
  ActivityEntityType as FeatureEntityType,
  AddBidEntitiesInput_Entities_EntityTypeEnum_0 as BidEntityType,
  AddLeadEntitiesInput_Entities_EntityTypeEnum_0 as LeadEntityType,
  AdminBulkRetriggerResponse_Results_NewStatusEnum_0 as CustomerDocumentStatus,
  AdminUpdateBuyerListSharingInput_SharingTypeEnum_0 as BuyerListSharingTypeEnum,
  AiChatsRequest_ResourceTypeEnum_0 as AiChatsResourceType,
  AiChatStreamResponse_Sources_DocumentTypeEnum_0 as AiSourceDocumentType,
  AiChatStreamResponse_Sources_TypeEnum_0 as AiSourceType,
  AiQuickPrompt_ScopeEnum_0 as AiQuickPromptScope,
  BasicNotice_EntityTypeEnum_0 as EntityType,
  BasicNotice_EntityTypeEnum_0 as NoticeEntityType,
  BasicNotice_StageEnum_0 as NoticesStages,
  BidOrchestratorStatusEvent_SectionEnum_0 as BidOrchestratorSection,
  BidOrchestratorStatusEvent_StatusEnum_0 as BidOrchestratorPhase,
  BidResponsesRequest_OrderByEnum_0 as BidResponseSortBy,
  BidResponsesRequest_OrderEnum_0 as BidResponseSortOrder,
  BuyerActivity_StatusEnum_0 as BuyerActivityStatus,
  CognismContact_TierEnum_0 as ContactTier,
  Company_SubscriptionEnum_0 as SubscriptionEnum,
  CompanyUserUsageRequest_PaymentTypeEnum_0 as UsagePaymentType,
  Contact_SourceEnum_0 as ContactSource,
  // Source enum for the unified contact SEARCH/REVEAL surface (CognismContact.source,
  // the reveal input + item). Distinct from `ContactSource` (the saved-contact
  // `Contact` type's enum) though the values match — they're separate GraphQL enums.
  ContactNodeSource as CognismContactSource,
  ContactsExportCredits_ResetCadenceEnum_0 as CreditResetCadence,
  CreateCommentRequest_ObjectTypeEnum_0 as CommentObjectType,
  CreateCustomOrganisationInput_PrimaryRoleEnum_0 as CustomOrganisationPrimaryRole,
  CreateLeadSubscriptionRequest_DestinationSettings_TypeEnum_0 as LeadSubscriptionDestinationType,
  CreatePromptInput_ModelEnum_0 as CreatePromptModel,
  CreatePromptInput_PromptTypeEnum_0 as CreatePromptType,
  CustomerDocumentRequest_ReviewStatusEnum_0 as CustomerDocumentReviewStatus,
  CustomerDocumentRequest_SortByEnum_0 as CustomerDocumentSortBy,
  CustomerDocumentRequest_SortOrderEnum_0 as CustomerDocumentSortOrder,
  DeleteCustomerDocumentRequest_DocumentTypeEnum_0 as CustomerDocumentType,
  DocumentsSearchRequest_CategoriesEnum_0 as DocumentCategory,
  DocumentsSearchRequest_RelationshipTypeEnum_0 as DocumentRelationshipType,
  DocumentsSearchRequest_SortEnum_0 as DocumentsSort,
  DocumentsSearchRequest_SortOrderEnum_0 as DocumentsSortOrder,
  ExportFormatArgs_FileFormatEnum_0 as Format,
  ExportOrganisationRequest_CountFieldsEnum_0 as ExportOrgCountField,
  ExportOrganisationRequest_Filters_PrimaryRoleEnum_0 as ExportOrgPrimaryRole,
  ExportOrganisationRequest_Filters_SortByEnum_0 as ExportOrgSortBy,
  ExportOrganisationRequest_Filters_SortOrderEnum_0 as ExportOrgSortOrder,
  GenerateBuyerActivitySummaryRequest_ObjectTypeEnum_0 as BuyerActivityObjectType,
  HiddenEntityInput_EntityTypeEnum_0 as HiddenEntityType,
  InternalNoticesSearchRequest_SortEnum_0 as NoticesSort,
  LogActivityRequest_ActionEnum_0 as LoggedAction,
  LogActivityRequest_EntityTypeEnum_0 as LoggedEntityType,
  MakeWebhookRequest_HookNameEnum_0 as MakeWebhookName,
  Notice_Contracts_Value_CurrencyEnum_0 as CurrencyEnum,
  Notice_ProcurementStage_StageEnum_0 as NoticeTimelineStage,
  Notice_RelatedFrameworkProcess_ProcessTypeEnum_0 as FrameworkProcessType,
  Notice_Timeline_Award_StageEnum_0 as NoticesStagesv2,
  NoticesAnalysisByGroupRequestSchema_GroupByEnum_0 as NoticeAnalysisByGroupGroupBy,
  NoticesAnalysisByGroupRequestSchema_SortEnum_0 as NoticeAnalysisByGroupSort,
  NoticesAnalysisByGroupRequestSchema_SortOrderEnum_0 as NoticeAnalysisByGroupSortOrder,
  NoticesAnalysisByPeriodRequestSchema_GroupByEnum_0 as NoticeAnalysisByPeriodGroupBy,
  NoticesAnalysisByPeriodRequestSchema_IntervalEnum_0 as NoticeAnalysisByPeriodInterval,
  NoticesCountRequestSchema_OrgTypeEnum_0 as OrgType,
  NoticesCountRequestSchema_SortOrderEnum_0 as NoticesCountSortOrder,
  NoticeTopicSearchInput_Filters_FrameworkActivityEnum_0 as FrameworkActivity,
  NoticeTopicSearchInput_Filters_SortEnum_0 as NoticesTopicSearchSort,
  NoticeTopicSearchInput_Filters_SortOrderEnum_0 as NoticesSortOrder,
  NoticeTopicSearchInput_Filters_StagesEnum_0 as NoticesTopicSearchInputStagesFilter,
  NoticeTopicSearchInput_Filters_SupplierMentionTypeEnum_0 as SupplierMentionType,
  PqlActionedInput_ActionTypeEnum_0 as PqlActionType,
  PromptTemplate_RoleEnum_0 as PromptRole,
  QualifyQuestionRequest_ReportTypeEnum_0 as BidReportType,
  ReorderAiQuickPromptsRequest_ChatTypeEnum_0 as AiQuickPromptChatType,
  RequestManagedResearchInput_RequestTypeEnum_0 as ManagedResearchRequestType,
  RevealContactResponse_StatusEnum_0 as RevealStatus,
  SavedViewsRequest_DataTypesEnum_0 as SavedViewDataType,
  SavedViewsRequest_OrderByEnum_0 as SavedViewSortBy,
  SavedViewsRequest_OrderEnum_0 as SavedViewSortOrder,
  SearchBidsRequest_OrderByEnum_0 as BidSortBy,
  SearchBidsRequest_OrderEnum_0 as BidSortOrder,
  SearchFrameworksRequest_AwardTypesEnum_0 as AwardType,
  SearchFrameworksRequest_BuyerParticipantTypeEnum_0 as BuyerParticipantType,
  SearchFrameworksRequest_ProcedureTypesEnum_0 as ProcedureType,
  SearchFrameworksRequest_SortOrderEnum_0 as SearchRequestSortOrder,
  SearchFrameworksRequest_StagesEnum_0 as FrameworkStages,
  SearchLeadsRequest_OrderByEnum_0 as LeadSortBy,
  SearchLeadsRequest_OrderEnum_0 as LeadSortOrder,
  SpendExportRequest_GroupByEnum_0 as SpendExportGroupBy,
  SpendExportRequest_OrderByEnum_0 as SpendTransactionOrderBy,
  SpendExportRequest_SortOrderEnum_0 as SpendSortOrder,
  SpendOverTimeByBuyerTypeRequest_DateUnitEnum_0 as SpendBuyerTypeTimeUnit,
  SpendOverTimeByBuyerTypeResponse_Points_BuyerTypeEnum_0 as SpendBuyerType,
  SpendOverTimeRequest_DateUnitEnum_0 as SpendTimeUnit,
  SpendOverTimeRequest_GroupByEnum_0 as SpendGroupBy,
  TeamManagementUsersRequest_PaymentTypeEnum_0 as TeamManagementPaymentType,
  TeamManagementUsersRequest_SortByEnum_0 as TeamManagementUserSortBy,
  TeamManagementUsersRequest_SortOrderEnum_0 as TeamManagementUserSortOrder,
  ToneOfVoiceProcessingStatusEvent_StatusEnum_0 as ToneOfVoiceProcessingStatus,
  TopSpendSuppliersRequest_OrderByEnum_0 as SpendSummaryOrderBy,
  UpdateBuyerListPermissionsInput_Updates_RoleNameEnum_0 as BuyerListRoleNameEnum,
  UpdateLeadSubscriptionContentRequest_FrequencyEnum_0 as LeadSubscriptionContentFrequency,
  UpdateLeadSubscriptionRequest_FrequencyEnum_0 as LeadSubscriptionFrequency,
} from "../generated/app-service-gql/graphql";

export {
  AwardType,
  // AwardType is the same enum as SearchRequestAwardType (Framework_AwardTypeEnum deduplicated)
  AwardType as SearchRequestAwardType,
  BuyerParticipantType,
  FrameworkActivity,
  NoticesCountSortOrder,
  NoticeEntityType,
  NoticeTimelineStage,
  NoticesSort,
  NoticesSortOrder,
  NoticesTopicSearchSort,
  NoticesStages,
  NoticesStagesv2,
  // NoticesTopicSearchInputStagesFilter is the same enum as NoticesStagesFilter
  NoticesTopicSearchInputStagesFilter,
  NoticesTopicSearchInputStagesFilter as NoticesStagesFilter,
  OrgType,
  ProcedureType,
  // ProcedureType is the same enum as SearchRequestProcedureType (Framework_ProcedureTypeEnum deduplicated)
  ProcedureType as SearchRequestProcedureType,
  SearchRequestSortOrder,
  FrameworkStages,
  // FrameworkStages is the same enum as FrameworkStagesSearch and TimelineStage (Framework_StageEnum deduplicated)
  FrameworkStages as FrameworkStagesSearch,
  FrameworkStages as TimelineStage,
  // CustomOrganisationPrimaryRole is used for create/update mutation inputs
  // ExportOrgPrimaryRole is used for Organisation.primaryRole responses and the search role filter
  CustomOrganisationPrimaryRole,
  ExportOrgPrimaryRole as OrgPrimaryRole,
  ExportOrgPrimaryRole as AnchorOrgRole,
  ExportOrgPrimaryRole as AnchorOrganisationType,
  ExportOrgPrimaryRole as SearchOrgRole,
  // ExportOrgSortBy is the same enum as OrgSortBy (awardCount|noticeCount enums deduplicated)
  ExportOrgSortBy,
  ExportOrgSortBy as OrgSortBy,
  // ExportOrgSortOrder is the same enum as OrgSortOrder (ASC|DESC enums deduplicated)
  ExportOrgSortOrder,
  ExportOrgSortOrder as OrgSortOrder,
  ExportOrgCountField,
  // CreatePromptModel is the same enum as PromptModel (Prompt_ModelEnum deduplicated)
  CreatePromptModel,
  CreatePromptModel as PromptModel,
  // CreatePromptType is the same enum as PromptType (Prompt_PromptTypeEnum deduplicated)
  CreatePromptType,
  CreatePromptType as PromptType,
  PromptRole,
  FrameworkProcessType,
  EntityType,
  SupplierMentionType,
  DocumentCategory,
  DocumentsSort,
  DocumentsSortOrder,
  DocumentRelationshipType,
  CommentObjectType,
  CurrencyEnum,
  BuyerActivityStatus,
  NoticeAnalysisByGroupGroupBy,
  NoticeAnalysisByGroupSort,
  NoticeAnalysisByGroupSortOrder,
  NoticeAnalysisByPeriodGroupBy,
  NoticeAnalysisByPeriodInterval,
  MakeWebhookName,
  AiChatsResourceType,
  // AiChatsResourceType is the same enum as AiChatStreamResourceType (deduplicated)
  AiChatsResourceType as AiChatStreamResourceType,
  // CustomerDocumentType is the same enum as CustomerDocumentTypeFilter and DeleteDocumentType
  // (all BID_DOCUMENT|CONTENT_LIBRARY|TONE_OF_VOICE_SOURCE enums deduplicated)
  CustomerDocumentType,
  CustomerDocumentType as CustomerDocumentTypeFilter,
  CustomerDocumentType as DeleteDocumentType,
  AiSourceType,
  CustomerDocumentSortBy,
  CustomerDocumentSortOrder,
  AiSourceDocumentType,
  AiQuickPromptChatType,
  AiQuickPromptScope,
  LeadSubscriptionFrequency,
  LeadSubscriptionFrequency as CreateSavedViewAlertFrequency,
  SavedViewDataType,
  CustomerDocumentReviewStatus,
  CustomerDocumentStatus,
  Format,
  SavedViewSortBy,
  SavedViewSortOrder,
  BidResponseSortBy,
  BidResponseSortOrder,
  LeadSubscriptionContentFrequency,
  LeadSubscriptionDestinationType,
  BidSortBy,
  BidSortOrder,
  BidEntityType,
  LeadSortBy,
  LeadSortOrder,
  LeadEntityType,
  BuyerActivityObjectType,
  BidReportType,
  BuyerListSharingTypeEnum,
  BuyerListRoleNameEnum,
  ToneOfVoiceProcessingStatus,
  BidOrchestratorPhase,
  BidOrchestratorSection,
  ContactSource,
  CognismContactSource,
  ContactTier,
  CreditResetCadence,
  RevealStatus,
  LoggedAction,
  LoggedEntityType,
  SubscriptionEnum,
  // Spend groupBy is a per-request enum: SpendGroupBy for the spend-over-time
  // series, SpendExportGroupBy for the export output shape (same values, distinct
  // types). topSpendBuyers/Suppliers share the order + sort enums.
  SpendGroupBy,
  SpendExportGroupBy,
  SpendTimeUnit,
  // The buyer type series is its own query, with its own time-unit enum.
  SpendBuyerType,
  SpendBuyerTypeTimeUnit,
  SpendSummaryOrderBy,
  SpendSortOrder,
  SpendTransactionOrderBy,
  ManagedResearchRequestType,
  TeamManagementPaymentType,
  TeamManagementUserSortBy,
  TeamManagementUserSortOrder,
  FeatureEntityType,
  UsagePaymentType,
  PqlActionType,
  HiddenEntityType,
};

// nestjs-graphql-zod USED TO generates a unique enum type per input type (e.g.
// QualifyQuestionRequest_ReportTypeEnum_0, BidResponsesRequest_OrderByEnum_0)
// for what is logically the same enum. TypeScript infers the correct
// target enum T from contextual typing at each call site. With this we don't
// have to do "var as unknown as T" at every call site
/** @deprecated nestjs-graphql-zod now dedupes enums automatically */
export const inferEnumType = <T>(value: unknown): T => {
  return value as string as T;
};
